import React from 'react';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const FAQ = ({ faqs, title, subtitle, WhatsAppClick }) => {
    if (!faqs || faqs.length === 0) return null;

    return (
        <section id="faq" className="py-20 bg-gradient-to-b from-gray-50 to-white">
            <div className="container mx-auto px-4">
                <div className="max-w-3xl mx-auto">
                    <div className="text-center space-y-4 mb-12">
                        <h2 className="text-4xl font-bold text-gray-900">
                            {title || 'Frequently Asked Questions'}
                        </h2>
                        <p className="text-lg text-gray-600">
                            {subtitle || 'Everything you need to know about our medications and services'}
                        </p>
                    </div>

                    <Accordion type="single" collapsible className="space-y-4">
                        {faqs.map((faq, index) => (
                            <AccordionItem
                                key={index}
                                value={`item-${index}`}
                                className="bg-white rounded-xl border border-gray-200 px-6 overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                            >
                                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-red-600 py-4 transition-colors">
                                    {faq.question}
                                </AccordionTrigger>
                                <AccordionContent className="text-gray-600 leading-relaxed pb-4">
                                    {faq.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                    <div className="mt-12 text-center">
                        <p className="text-gray-600 mb-4">Still have questions?</p>
                        <Button
                            onClick={WhatsAppClick}
                            className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-semibold flex items-center justify-center space-x-2 mx-auto shadow-lg hover:shadow-xl transition-all"
                        >
                            <MessageCircle className="w-5 h-5" />
                            <span>Chat with Our Experts</span>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQ;
